// TODO: @lisilinhart we can probably remove this function in the future
// it's only used in a single place in `arrayUtils` when the "old way" is used

// TODO: @emanuelgsouza we need to add tests and refactor this code to
// understand how it should work to be used in the arrayUtils.find method

import decycle from './decycle'

export default function deepSearch(where, searchKey, what): unknown {
  const res = []

  function match(obj, key): boolean {
    return searchKey === key && obj[key] === what
  }

  function innerSearch(o, v): unknown {
    const search = function (obj, pattern, prefix): unknown {
      prefix = prefix || ''
      return function (a): void {
        if (typeof obj[a] === 'object' && obj[a] !== null) {
          Object.keys(obj[a]).forEach(
            search(
              obj[a],
              pattern,
              /\d+/.test(a)
                ? prefix + '[' + a + ']'
                : (prefix !== '' ? prefix + '.' : '') + a,
            ),
          )
        } else {
          if (match(obj, a)) {
            res.push(obj)
          }
        }
      }
    }
    o = decycle(o)

    Object.keys(o).forEach(search(o, v))
  }

  innerSearch(where, what)

  return res
}
